import Swal from "sweetalert2";

async function Relacionamento(laboratorio, otica) {
  var relacionamento = false;
  const requestOptions = {
    method: "GET",
    headers: {
      access_token: sessionStorage.getItem("token"),
      client_id: localStorage.getItem("clientid"),
      otica: otica,
      laboratorio: laboratorio,
    },
  };

    await fetch(process.env.REACT_APP_ESSILOR_API + `gestao-laboratorios/v1/relacionamento`, requestOptions)
    .then(response => {
     
        return response.json();
    
    })
    .then(async json => {
      if (json && json[0]?.mensagem) {
        Swal.fire({
          html: json[0].mensagem,
          icon: "warning",
          title: "Aviso",
          confirmButtonColor: "#00518b",
          customClass: {
            confirmButton: "x-follow-order__filter-btn",
          },
        });
        relacionamento = null;
      }
      if (json && json.relacionamento === true) {
        relacionamento = true;
      }else{
        relacionamento = false;
      }
    });
return relacionamento;
  
}

export  { Relacionamento };
